import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./globalSettingsSlice";

const selectDomain = (state) => state.globalSettings || initialState;

export const makeSelectQuery = createSelector(
  selectDomain,
  (state) => state.query
);

export const makeSelectOne = createSelector(selectDomain, (state) => state.one);
